export const PAST_BOUNDARY_DATES = {
  all: 'filters.date.future_dates_range.all',
  today: 'filters.date.past_dates_range.today',
  '3_days': 'filters.date.past_dates_range.3_days',
  '7_days': 'filters.date.past_dates_range.7_days',
  '30_days': 'filters.date.past_dates_range.30_days',
};
export const PER_PAGE = { 25: 25, 50: 50, 100: 100 };
export const DEFAULT_PER_PAGE = 25;
export const STATUS_VALUES = {
  published: true,
  unpublished: false,
};
export const PUBLISHED = 'published';
export const UNPUBLISHED = 'unpublished';
export const CATALOG_LIVE_TYPE = 'live';
export const LACK = 'lack';
export const SOLD_CONDITIONALLY_STATE = 'sold_conditionally';
export const SOLD_STATE = 'sold';
export const UNSOLD_STATE = 'unsold';
export const BID_AUDIENCE = 'bid_audience';
export const BID_APP = 'bid_app';
export const BID_PHONE = 'bid_phone';
export const SEARCH_TIMEOUT = 1000;



// WEBPACK FOOTER //
// ./app/javascript/packs/employees/consts.js